import React from "react";
import t, {changeLanguage} from "../../components/I18N/TranslateHelpers";
import {GetCurrentLocale} from "../../components/Utils";
import {RootState} from "../../app/RootReducer";
import {useDispatch, useSelector} from "react-redux";
import {SpinnerOnTop} from "../../components/SpinnerOnTop";
import {LocalParams} from "../../components/LocalParams";
import CartSummaryTotal from "./CartSummaryTotal";
import HtmlForItemProduct from "../Products/HtmlForItemProduct";


interface ComponentProps {
  activeStep: number
}

const CartSummary = ({activeStep}:ComponentProps) => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)

  const dispatch = useDispatch()
  const tokenCart = LocalParams.getItem('tokenCart') as string
  const itemsInCart = useSelector((state: RootState) => state.cartRdc.cart )
  const isRequesting = useSelector((state: RootState) => state.cartRdc.isRequesting )
  const isRequestingDelete = useSelector((state: RootState) => state.cartRdc.isRequestingDelete )

  const isRequestingAdd = useSelector((state:RootState) => state.userRdc.isRequestingAdd)
  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);

  return (
    <>
      <h4 className="card-title mb-4">{ t('your_cart')}</h4>
      {
        isRequestingDelete || isRequesting?
          <SpinnerOnTop/>
          :
            itemsInCart && itemsInCart.items && itemsInCart.items.length > 0 ?
              itemsInCart.items.map((productItem, index) => {
                return(
                  <React.Fragment key={index}>
                    <HtmlForItemProduct
                      productItem={productItem}
                      isForCart={true}
                      isItemForRequestOffer={false}
                      tokenValue={tokenCart}
                      isRequestingAdd={isRequestingAdd}
                      dispatch={dispatch}
                      />
                    {
                      index !== itemsInCart.items.length - 1 ?
                      <hr  key={index}/>
                      : null
                    }
                  </React.Fragment>
              )
              })
            :
            <div className="alert alert-warning">{t('no_product_in_cart')}</div>
      }
      {
        itemsInCart && itemsInCart.items && itemsInCart.items.length > 0 ?
          <CartSummaryTotal itemsInCart={itemsInCart} activeStep={activeStep}/>
          : null
      }

    </>
  )
}

export default CartSummary;
